import styled from 'styled-components';
import TextButton from 'components/TextButton';

export const Button = styled(TextButton)`
  padding: 10px 16px;
`;
